import _regeneratorRuntime from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { generateTitle } from '@/utils/i18n';
export default {
  computed: {
    language: function language() {
      return this.$store.getters.language ? this.$store.getters.language : 0;
    }
  },
  methods: {
    generateTitle: generateTitle,
    handleSetLanguage: function handleSetLanguage(lang) {
      // console.log(lang)
      this.$i18n.locale = lang;
      var languageCodes = {
        en: 0,
        zh: 1,
        tw: 2
      };
      var languageCode = languageCodes[lang];
      // console.log(languageCode)
      this.$store.dispatch('app/setLanguage', languageCode);
      this.loadDataDictionary(languageCode);
      this.$message({
        message: this.$t('index.switch_language'),
        type: 'success'
      });
      var randomNum = Math.round(Math.random() * 10000);
      this.$router.push('/?' + randomNum);
    },
    loadDataDictionary: function () {
      var _loadDataDictionary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(lang) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('tableDataDictionary/getTableDataDictionary', lang).then(function () {
                console.log('Load tableDataDictionary success');
              }).catch(function () {
                console.log('Load tableDataDictionary failed');
              });
            case 2:
              _context.next = 4;
              return this.$store.dispatch('codeDataDictionary/getCodeDataDictionary', lang).then(function () {
                console.log('Load codeDataDictionary success');
              }).catch(function () {
                console.log('Load codeDataDictionary failed');
              });
            case 4:
              return _context.abrupt("return", true);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadDataDictionary(_x) {
        return _loadDataDictionary.apply(this, arguments);
      }
      return loadDataDictionary;
    }()
  }
};